import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractType } from './abstract-type';

@inheritSerialization(AbstractType)
export class OperationalFootprintInfo extends AbstractType {
  @autoserialize
  latitude: number;

  @autoserialize
  longitude: number;
}
